import { TenantBookingCancellationReasons } from './types/BookingCancellation';
import { MakeCall } from './createMakeCall';

export interface TenantBookingCancellationPayload {
  message: string;
  attachments: string[];
  cancellationReasons: TenantBookingCancellationReasons;
}

const cancelBooking =
  (makeCall: MakeCall) =>
  (conversationId: number, data: TenantBookingCancellationPayload) =>
    makeCall('POST', `/api/v2/conversation/${conversationId}/booking-cancel`, {
      data,
    });

export { cancelBooking };
